<template lang="html">

  <div class="cover-popup row-center">

    <div class="encuestas-obligatorias-view">

      <h2 :style="style.colorBasic">{{ $t('encuestas.titulo') }}</h2>
      <p v-if="data.length > 1" v-html="$t('encuestas.cuerpo_plural')"></p>
      <p v-else v-html="$t('encuestas.cuerpo')"></p>

      <section class="listado-encuestas column-center">

        <template v-for="(encuesta, key) in data">
          <encuesta-el :prop="encuesta" :key="key"></encuesta-el>
        </template>

        <p class="aviso" v-html="$t('encuestas.no_puedes')"></p>

        <router-link :to="$t('enlaces.logout')" class="btn -skull-primary">{{ $t('cerrar_sesion') }}</router-link>

      </section>

    </div>

  </div>

</template>

<script lang="js">

import { mapGetters } from 'vuex';

import encuestaEl from '@/components/parts/encuesta-el';

export default {
  name: 'encuestas-obligatorias',
  computed: {
    ...mapGetters({
      data: 'getEncuestasObligatorias',
      colors: 'basicColors',
      style: 'getStyles'
    })
  },
  components: {
    'encuesta-el': encuestaEl
  }
}
</script>

<style scoped lang="scss">
.cover-popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  background: rgba(0, 0, 0, .6);
  padding: 15px;
}

.encuestas-obligatorias-view {
  background: white;
  width: 100%;
  max-width: 600px;
  padding: 50px 20px;
}

.encuestas-view {
  padding: 50px 0;
  width: 100%;
  display: inline-block;
}

h2 {
  font-weight: 800;
  width: 100%;
  font-size: 24px;
  margin-bottom: 10px;
  text-align: left;
}

p {
  margin-bottom: 20px;

  &.aviso {
    font-weight: bold;
    margin-top: 20px;
  }
}

.listado-encuestas {
  width: 100%;
  max-width: 800px;
}

.btn {
  margin-top: 0px;
}

@media screen and (max-width: 500px) {
  h2 {
    font-size: 24px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/encuestas-obligatorias.vue